// extracted by mini-css-extract-plugin
export default {"calendar":"DateSelect-module--calendar--b3075"};